// extracted by mini-css-extract-plugin
module.exports = {"link":"about-module--link--3h97c"};